import { render, staticRenderFns } from "./BankSrc.vue?vue&type=template&id=12e1731e"
import script from "./BankSrc.vue?vue&type=script&lang=js"
export * from "./BankSrc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports